module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contentWrap"
    }
  }, [_c('div', {
    staticClass: "content right"
  }, [_c('div', {
    staticClass: "right",
    attrs: {
      "id": "content_1block"
    }
  }, [_c('div', {
    staticClass: "response"
  }, [_c('div', {
    staticClass: "resendmail linkfont"
  }, [_c('span', {
    staticStyle: {
      "color": "#009A21"
    }
  }, [_vm._v("یک لینک جهت ریست و بازیابی رمز عبور شما برایتان ارسال گردید. "), _c('a', {
    attrs: {
      "href": "javascript: void(0)"
    }
  }, [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('p', [_vm._v("درصورت عدم دریافت ایمیل، لطفا کلیک کنید روی "), _c('a', {
    attrs: {
      "href": "javascript: void(0)"
    },
    on: {
      "click": function($event) {
        _vm.ResendMail()
      }
    }
  }, [_vm._v("اینجا")]), _vm._v(" تا ایمیل دوباره ارسال گردد.")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "200px",
      "margin-right": "auto",
      "margin": "auto"
    }
  }, [_c('button', {
    staticClass: "button-warning pure-button button-download",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_vm._v("بازگشت به صفحه اصلی")])])]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-643d2d50!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/ResendMail.vue
// module id = 107
// module chunks = 1